import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../common-modal/CommonModal';
import CommonButton from '../common-button/CommonButton';

import './UnsavedModal.scss';

const UnsavedModal = ({ isOpen, onClose, onCancel, onSave, onDontSave, label, subLabel }) => {
  const { t } = useTranslation();

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName='unsaved-modal_wrapper' hideCloseIcon>
      <h3 className='unsaved-modal_text'>{label || t('unsavedChanges')}</h3>

      <span className='unsaved-modal_sub-text'>{subLabel || t('doYouWantToSaveChanges')}</span>

      <div className='unsaved-modal_actions'>
        <CommonButton type='button' styleColor='secondary' maxWidth={90} onClick={onCancel}>
          {t('cancel')}
        </CommonButton>

        <div className='unsaved-modal_actions--right'>
          <CommonButton type='button' styleColor='secondary' maxWidth={100} onClick={onDontSave}>
            {t('dontSave')}
          </CommonButton>

          <CommonButton type='button' styleColor='primary' maxWidth={100} onClick={onSave}>
            {t('save')}
          </CommonButton>
        </div>
      </div>
    </CommonModal>
  );
};

export default memo(UnsavedModal);
